import { useEffect, useState } from "react";
import axios from "axios";
export default function useProfileGallery(pageNumber, token, viewMore) {
  const [dataloading, setDataLoading] = useState(true);
  const [error, setError] = useState(false);
  const [profileContent, setProfileContent] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    setProfileContent([]);
  }, []);

  useEffect(() => {
    setDataLoading(true);
    setError(false);
    let cancel;
    let url = "";
    if (!viewMore) {
      url = `${process.env.REACT_APP_PROFILE_ENTRIES}?page=1&limit=9`;
    } else {
      url = `${process.env.REACT_APP_PROFILE_ENTRIES}?page=${pageNumber}&limit=9`;
    }
    axios({
      method: "get",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    })
      .then((res) => {
        if (!viewMore) {
          setProfileContent(res?.data?.data);
          setHasMore(false);
        } else {
          setProfileContent((prevProfileData) => {
            const newItems = Array.isArray(res?.data?.data)
              ? res?.data?.data
              : [];
            return [...new Set([...prevProfileData, ...newItems])];
          });
          setHasMore(res.data.data.length > 0);
        }
        setDataLoading(false);
      })
      .catch((e) => {
        setDataLoading(false);
        setProfileContent([]);
        if (axios.isCancel(e)) return;
        setError(true);
      });
    return () => cancel();
  }, [pageNumber, viewMore]);

  return { dataloading, error, profileContent, hasMore };
}
